const numberCompaniesBucket = [
  { label: '0-1 clients', value: '0-1' },
  { label: '2-4 clients', value: '2-4' },
  { label: '5-9 clients', value: '5-9' },
  { label: '10-24 clients', value: '10-24' },
  { label: '25-49 clients', value: '25-49' },
  { label: '50-249 clients', value: '50-249' },
  { label: '250-999 clients', value: '250-999' },
  { label: '1000+ clients', value: '1000' },
];

export default numberCompaniesBucket;
